import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const OngoingSessions = () => {
	const [sessions, setSessions] = useState<any[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		fetch("https://backend-kyw8.onrender.com/session/ongoing")
			.then((response) => response.json())
			.then((data) => {
				setSessions(data.sessions); // Accessing the 'sessions' array in the data
				setLoading(false);
			})
			.catch((error) => {
				console.error("Error fetching sessions:", error);
				setLoading(false);
			});
	}, []);

	return (
		<div className="main-div p-6 bg-gray-100 min-h-screen">
			<h2 className="text-3xl font-bold text-center mb-6 text-gray-800">
				Ongoing Court Sessions
			</h2>
			{loading ? (
				<div className="flex justify-center items-center mt-10">
					<div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-20 w-20"></div>
				</div>
			) : sessions.length === 0 ? (
				<p className="text-center text-lg text-gray-600">
					No ongoing sessions at the moment.
				</p>
			) : (
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
					{sessions.map((session) => (
						<div
							key={session.id}
							className="bg-white p-5 rounded-lg shadow-lg border border-gray-200">
							<h3 className="text-xl font-semibold text-gray-700 mb-2">
								{session.sessionName}
							</h3>
							<Link
								to={`/public-hearing/${session.caseId}/${session.sessionName}`}>Join session</Link>
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default OngoingSessions;
